import React from 'react';
import Header from '@/components/site/Header';
import Hero from '@/components/site/Hero';
import HomeProblem from '@/components/site/HomeProblem';
import HomeSystem from '@/components/site/HomeSystem';
import HomeWhy from '@/components/site/HomeWhy';
import ContactForm from '@/components/site/ContactForm';
import Footer from '@/components/site/Footer';
import WhatsAppFloat from '@/components/site/WhatsAppFloat';
import CookieBanner from '@/components/site/CookieBanner';
import StickyMobileCTA from '@/components/site/StickyMobileCTA';
import AnalyticsBeacon from '@/components/AnalyticsBeacon';

// =============================================================================
// Home V2 — premium medical SRL, lead-first, 4 sections.
//
// Composition:
//   1. Hero            — title + decision cards (demo/brochure/whatsapp) + trust strip + product preview
//   2. HomeProblem     — real pain of the practice in 3 messages
//   3. HomeSystem      — the Prime Vision system as 4 pillars
//   4. HomeWhy         — 3 concrete reasons to choose + CTAs to demo and full comparison
//   5. ContactForm     — final lead capture
//
// Dedicated marketing sections live on their own routes:
//   /chi-siamo, /perche-sceglierci, /a-chi-ci-rivolgiamo, /faq, /contatti
// Lead-gen routes: /fse, /brochure, /bookacall (+ aliases).
// =============================================================================

const LandingPage = () => {
  return (
    <main
      className="relative bg-white text-pv-ink min-h-screen overflow-x-hidden"
      data-testid="pv-landing-page"
    >
      <Header />
      <Hero />
      <HomeProblem />
      <HomeSystem />
      <HomeWhy />
      <ContactForm />
      <Footer />
      <WhatsAppFloat />
      <StickyMobileCTA />
      <CookieBanner />
      <AnalyticsBeacon />
    </main>
  );
};

export default LandingPage;
